import React, { useState, useEffect} from 'react';
import '../../css/pages.css';
import language from '../../utils/LanguageSettings';
import { fetchSubscriberEnquiry } from '../functions/fetchSubscriberEnquiry';
import { SOURCE_URL } from '../../config';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import RenderSnA from '../functions/renderSnA';
import { useAuth } from '../../contexts/AuthProvider';

const SubscriberEnquiry: React.FC = () => {
  const { userData, ready } = useAuth();
  const query = new URLSearchParams(window.location.search);
  const para_type = query.get('para_type') || '';
  const customer_type = query.get('customer_type') || '';
  const combo_title = query.get('combo_title') || '';
  const full_chat_url = query.get('full_chat_url') || '';
  const [loading, setLoading] = useState<boolean>(true);
  const [content, setContent] = useState<any>();
  const [seo, setSeo] = useState<any>(null);
  const [ga, setGa] = useState<any>(null);
  const title_mapping = (language == 'en' ?        {
            'main_title_7_upgrade' : 'Hello! Thanks for being a subscriber.',
            'main_title_7_subscribe' : 'Hello!',
            'sub_title_7' : 'To subscribe or upgrade, please Live Chat or give us a call.<br/>We’ll get your subscription updated in no time!',
            'sub_title_7_lib' : 'To subscribe or upgrade, please Live Chat or give us a call.<br/>We’ll get your subscription updated in no time!',
            'sub_title_7_cnl' : 'To subscribe or upgrade, please Live Chat or give us a call.<br/>We’ll get your subscription updated in no time!'
        }
        :
        {
            'main_title_7_upgrade' : '想額外訂購其他頻道組合？',
            'main_title_7_subscribe' : '想額外訂購其他頻道組合？',
            'sub_title_7' : '請透過線上對話或致電與我們聯絡，<br/>我們會盡快為你安排！',
            'sub_title_7_lib' : '請透過線上對話或致電與我們聯絡，<br/>我們會盡快為你安排！',
            'sub_title_7_cnl' : '請透過線上對話或致電與我們聯絡，<br/>我們會盡快為你安排！'
        }
    );

  useEffect(() => {
    const fetchData = async () => {
        let data = await fetchSubscriberEnquiry(language);
        if(data){
          setContent(data?.attributes);
          setSeo(data?.attributes?.SEO || null);
          setGa(data?.attributes?.GA || null);
        }
        setLoading(false);
    };
    fetchData();
  }, [language]);

  if (loading) {
    return (<>
        <div id="loader">
            <div className="spinner-border"></div>
        </div>
    </>
    );
  }
  
  return (
    <>
    <RenderSnA seo={seo} ga={ga} />
    <div id="main-content" className="enquiry spacer">
        <div className="container-fluid container-md text-center">
            {(customer_type == 'new' || customer_type == 'existing')
            ?
            <>
            <h2 className='font-medium mb-3'>{customer_type == 'existing' ? title_mapping.main_title_7_upgrade : title_mapping.main_title_7_subscribe}</h2>
            <p className='my-5 light-gray barlow-font'>
                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{para_type == 'cnl' ? title_mapping.sub_title_7_cnl : para_type == 'lib' ? title_mapping.sub_title_7_lib : title_mapping.sub_title_7}</ReactMarkdown>
            </p>
            </>
            :
            <>
            <h2 className='font-medium mb-3'>{content?.HeaderTagline}</h2>
            {combo_title ? <h4 className='font-medium'>{"Add " + combo_title + " to your subscription"}</h4> : <></>}
            <p className='my-5 light-gray barlow-font'>
                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content?.Introduction?.replace(/\n/g, '<br />') || ''}</ReactMarkdown>
            </p>
            </>
            }
            <div className='row justify-content-center mb-5'>
                {content?.ChatIcon?.data?.attributes?.url ?
                <div className='col-md-3 col-sm-6 mb-5'>
                    <a href={full_chat_url || content?.ChatLink || '#'}>
                  <img src={SOURCE_URL + content?.ChatIcon?.data?.attributes?.url} className='img-fluid chat-call-icons d-block mx-auto' alt={content?.ChatLabel || 'Chat'} />
                        <span className='font-weight-bold barlow-font d-block mt-3'>{content?.ChatLabel}</span>
                    </a>
                </div>
                :<></>}
                {content?.CallIcon?.data?.attributes?.url ?
                <div className='col-md-3 col-sm-6 mb-5'>
                    <a href={content?.CallLink ? content?.CallLink : "#"}>
                  <img src={SOURCE_URL + content?.CallIcon?.data?.attributes?.url} className='img-fluid chat-call-icons d-block mx-auto' alt={content?.CallLabel || 'Call'} />
                        <span className='font-weight-bold barlow-font d-block mt-3'>{content?.CallLabel}</span>
                    </a>                 
                </div>
                :<></>}
            </div>
        </div>
    </div>
    </>
  );
};

export default SubscriberEnquiry;